import { ApexWithdrawalForm } from '../../../../investment/components/transfer/ApexWithdrawalForm';

export default function WithdrawalPage() {
    return <ApexWithdrawalForm />;
}
